<template>
  <div class="container--large">
    <div class="calculator price__calculator">
      <div class="row">
        <div class="col col--8">
          <div class="calculator__card">
            <div class="calculator__title">Storage and Transfer Calculator</div>

            <template v-for="(conf, index) in config">
              <slider-item
                @handle-storage="handleStorage"
                :item="conf"
                :key="conf.title + index"
                ref="sliderItems"
              />
            </template>
          </div>
        </div>
        <div class="col col--4">
          <div class="calculator__plan">
            <div class="calculator__subtitle">You will need</div>
            <div class="calculator__title">
              Business {{ planComputed.key }} plan
            </div>

            <div class="calculator__feature">
              <div>
                <span class="calculator__storage"
                  >{{ planComputed.key }} GB</span
                >
                storage
              </div>
              <div>
                <span class="calculator__storage"
                  >{{ planComputed["Data transfer limit"] }} GB</span
                >
                transfer
              </div>
            </div>

            <div
              class="calculator__cost flex flex--align-center flex--justify-center"
            >
              {{ currency }}
              <span class="calculator__amount"> {{ price }} </span
              ><span class="calculator__time">/month</span>
            </div>
            <div class="calculator__anual">Annual, paid monthly</div>
            <div class="calculator__action">
              <a href="https://my.sirv.com/#/signup">
                <button class="btn btn--primary">
                  Start a 30-day free trial
                </button>
              </a>
            </div>
          </div>
          <div class="calculator__plan-heading">
            <h5>Estimated usage:</h5>
            <div>{{ storageToGB }} GB storage</div>
            <div>{{ transferToGB }} GB transfer</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import settings from "./assets/settings.json";
import SliderItem from "./components/SliderItem";

export default {
  name: "App",
  components: { SliderItem },
  provide() {
    return {
      closeAllSelects: () => this.closeAllSelects(),
    };
  },
  data() {
    return {
      storage: 0,
      transfer: 0,
      calculator: null,
      plan: null,
    };
  },
  created() {
    window.addEventListener("click", this.handleCloseSelect);
    this.calculator = window.Calculator;
    this.plan = {
      "5 GB storage": {
        monthly: 19,
        annual: 17,
        "Data transfer limit": 20,
      },
      "12 GB storage": {
        monthly: 39,
        annual: 35,
        "Data transfer limit": 48,
      },
      "20 GB storage": {
        monthly: 59,
        annual: 53,
        "Data transfer limit": 80,
      },
      "40 GB storage": {
        monthly: 89,
        annual: 82,
        "Data transfer limit": 160,
      },
      "60 GB storage": {
        monthly: 119,
        annual: 109,
        "Data transfer limit": 240,
      },
      "100 GB storage": {
        monthly: 199,
        annual: 182,
        "Data transfer limit": 400,
      },
      "200 GB storage": {
        monthly: 359,
        annual: 329,
        "Data transfer limit": 800,
      },
      "350 GB storage": {
        monthly: 599,
        annual: 549,
        "Data transfer limit": 1400,
      },
      "500 GB storage": {
        monthly: 849,
        annual: 778,
        "Data transfer limit": 2000,
      },
    };
  },
  computed: {
    config() {
      return settings;
    },

    currency() {
      return window.Calculator.currency.split(" ")[0];
    },

    normalizePlanObject() {
      let obj = {};
      for (const property in this.plan) {
        let key = parseInt(property);

        obj[key] = { ...this.plan[property] };
      }
      return obj;
    },

    planComputed() {
      let plan = null;
      let keys = Object.keys(this.normalizePlanObject);

      if (
        parseInt(this.storageToGB) > parseInt(keys[keys.length - 1]) ||
        parseInt(this.transferToGB) >
          parseInt(
            this.normalizePlanObject[keys[keys.length - 1]][
              "Data transfer limit"
            ]
          )
      ) {
        plan = this.normalizePlanObject[keys[keys.length - 1]];
        plan.key = keys[keys.length - 1];
        return plan;
      }

      for (const property in this.normalizePlanObject) {
        if (parseInt(property) >= parseInt(this.storageToGB)) {
          if (
            parseInt(
              this.normalizePlanObject[property]["Data transfer limit"]
            ) >= parseInt(this.transferToGB)
          ) {
            plan = this.normalizePlanObject[property];
            plan.key = property;
            break;
          }
        }
      }

      return plan;
    },

    rates() {
      return this.calculator.rates[
        this.calculator.currency.split(" ")[1]
      ].toFixed(1);
    },

    price() {
      return Math.ceil(this.planComputed.monthly * this.rates).toFixed();
    },

    storageToGB() {
      return (+this.storage / 1000).toFixed();
    },

    transferToGB() {
      return ((+this.transfer).toFixed() / 1000).toFixed();
    },
  },

  mounted() {
    this.handleStorage();
  },

  methods: {
    closeAllSelects() {
      const items = this.$refs.sliderItems;
      if (Array.isArray(items)) {
        items.forEach((c) => c && c.closeSelects && c.closeSelects());
      }
    },
    handleCloseSelect(e) {
      if (!e.target.closest(".select")) {
        this.closeAllSelects();
      }
    },

    handleStorage() {
      this.storage = 0;
      this.transfer = 0;
      for (let i = 0, len = this.$refs.sliderItems.length; i < len; i++) {
        let {
          input,
          select,
          key,
          mb = null,
        } = this.$refs.sliderItems[i].storage;

        if (key !== "Page views per month") {
          if (select && mb) {
            this.storage += +input * +select * +mb;
          }
          if (select && !mb) {
            this.storage += +input * +select;
          }
          this.storage += +input * +mb;

          continue;
        }

        this.transfer =
          +input * (0.15 * 1.1 + 0.14 * 0.9 + 0.6 * 0.9 + 0.1 * 0.55);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleCloseSelect);
  },
};
</script>

<style></style>
